import { useState } from "react";
import { Outlet, useLocation, Link, NavLink } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { useRealtime } from "@/hooks/useRealtime";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { MOBILE_NAV, NAV_ITEMS } from "@/lib/nav";
import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";

function Breadcrumb() {
  const location = useLocation();
  const parts = location.pathname.split("/").filter(Boolean);
  const labelFor = (seg) => {
    const item = NAV_ITEMS.find((i) => i.to === `/${seg}`);
    if (item) return item.label;
    return seg.charAt(0).toUpperCase() + seg.slice(1).replace(/-/g, " ");
  };
  return (
    <nav className="mb-1 flex items-center gap-1.5 text-sm text-muted-foreground" data-testid="breadcrumb">
      <Link to="/dashboard" className="hover:text-foreground">Home</Link>
      {parts.map((p, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <ChevronRight className="h-3.5 w-3.5" />
          <span className={cn(i === parts.length - 1 && "text-foreground font-medium")}>{labelFor(p)}</span>
        </span>
      ))}
    </nav>
  );
}

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false);
  useRealtime(true);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="w-64 p-0">
          <Sidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar onOpenSidebar={() => setMobileOpen(true)} />
        <main className="flex-1 overflow-y-auto pb-20 lg:pb-0">
          <div className="mx-auto w-full max-w-7xl p-4 md:p-8">
            <Breadcrumb />
            <div className="animate-fade-in-up">
              <Outlet />
            </div>
          </div>
        </main>
      </div>

      {/* Mobile bottom navigation */}
      <nav className="fixed bottom-0 left-0 right-0 z-30 flex items-center justify-around border-t border-border bg-background/95 backdrop-blur-xl lg:hidden" data-testid="bottom-nav">
        {MOBILE_NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn("flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors",
                isActive ? "text-primary" : "text-muted-foreground")
            }
          >
            <item.icon className="h-5 w-5" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
